<template>
    <div>
        <b-row>
          <b-col cols="auto" class="mr-auto">
            
          </b-col>
          <b-col cols="auto" class="">
            <b-form-group>
                <b-button variant="github" class="mr-1 btn-brand" @click="openModal(null)"><i class="fa fa-print"></i><span>Imprimir Etiquetas</span></b-button>
            </b-form-group>
          </b-col>
        </b-row>
            
        <b-row>
            <b-col cols="auto">
              <b-form-group>
                  <label for="name" style="font-size: 0.8em">Inicial</label>
                  <b-form-input v-model="filters.labelStart" type="number" id="labelStart" :min="item.labelStart" :max="item.labelEnd"></b-form-input>
              </b-form-group>
            </b-col>

            <b-col cols="auto">
                <b-form-group>
                  <label for="name" style="font-size: 0.8em">Final</label>
                  <b-form-input v-model="filters.labelEnd" type="number" id="labelEnd" :min="item.labelStart" :max="item.labelEnd"></b-form-input>
              </b-form-group>
            </b-col>

            <b-col cols="auto">
                <b-form-group>
                    <label for="statusId" style="font-size: 0.8em">Status</label>
                    <b-form-select id="statusId"
                    v-model="filters.statusId"
                    :plain="true"
                    :options="selectStatusDDL">
                    </b-form-select>
                </b-form-group>
            </b-col>
            
            <b-col cols="auto" class="mr-auto" style="padding-top: 12px;">
              <b-form-group>
                <p></p>
                <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="refreshData()"><i class="fa fa-search"></i><span>Localizar</span></b-button>
              </b-form-group>
            </b-col>
            
            <b-col cols="auto" class="">
                <b-form-group >
                    <label for="perPage" style="font-size: 0.8em">Linhas</label>
                    <b-form-select v-model="categoryTable.perPage" id="perPage"
                    :plain="true"
                    :options="[20,50,100,250,500]">
                    </b-form-select>
                </b-form-group>
            </b-col>
            
            
            
           
            
        </b-row>
        
          
        <b-form>
            <div class="animated fadeIn">                
                
            <b-row>
                <b-col md="12">
                
                <b-table :items="items"
                    :fields="categoryTable.fields" 
                    :select-mode="categoryTable.selectMode" 
                    responsive="sm" 
                    primary-key="id" 
                    :tbody-transition-props="categoryTable.transProps" 
                    sort-icon-left
                    @row-clicked="rowClicked"
                    :per-page="categoryTable.perPage" 
                    :current-page="categoryTable.currentPage" 
                    :busy="categoryTable.isBusy" 
                    hover striped                    
                    >

                    <template #table-busy>
    
                    <div class="text-center text-danger my-2">
    
                        <b-spinner class="align-middle"></b-spinner>
    
                        <strong>Carregando...</strong>
    
                    </div>
                    </template>
                                
                    <!-- Example scoped slot for select state illustrative purposes -->
                    <template #cell(selected)="{ rowSelected }">
                        <template v-if="rowSelected">
                        
                                        <span aria-hidden="true">&check;</span>
                        
                                        <span class="sr-only">Selected</span>
                    </template>
                    <template v-else>
                        <span aria-hidden="true">&nbsp;</span>
                        
                        <span class="sr-only">Not selected</span>
                    </template>
                                </template>

                    <template v-slot:cell(labelNumber)="data">
                        {{ String(data.item.labelNumber).padStart(5,'0') }}
                    </template>

                    <template v-slot:cell(printDate)="data">
                        {{ $utils.localDateTime(data.item.printDate) }}
                    </template>

                    <template v-slot:cell(action)="data">
                        <b-button size="sm" variant="primary" @click="openReprintModal(data.item)" class="mr-1 btn-brand"><i class="fa fa-print"></i></b-button>
                    </template>

                    <template v-slot:cell(st)="data">
                        <c-switch class="" color="primary" :checked="data.item.st=='A'" label variant="pill" v-bind="switchLabelIcon" />
                    </template>
                                
                                
                </b-table>
                <nav>
                    <b-pagination :total-rows="totalRows" :per-page="categoryTable.perPage" v-model="categoryTable.currentPage" prev-text="Anterior" next-text="Próximo" />
                </nav>
                
                </b-col>
            </b-row>

            </div>
        </b-form>

        <b-modal
            v-model="modal"
            id="modal"
            centered
            hide-footer
            title="Etiquetas Impressas"
            size="lg">
            <b-card>

                <b-form @submit.stop.prevent="onSubmit">
                
                <div class="animated fadeIn">
                    <b-row>
                        <b-col md="12">
                            <b-form-group>
                                <label for="name" style="font-size: 0.8em">Impressora</label>
                                <b-form-select id="printerId"
                                    v-model="printerId"
                                    :plain="true"
                                    :options="printerDDL"
                                    :class="printerField"
                                    >
                                </b-form-select>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="12">
                            <b-form>
                            <b-form-group
                            description=""
                            label="Inicial"
                            label-for="name"
                            :label-cols="2"
                            :horizontal="true">
                                <b-row>
                                    <b-col><b-form-input v-model="labelStart" id="labelStart" type="number" :min="item.labelStart" :max="item.labelEnd" :class="labelStartField"></b-form-input></b-col>
                                    <b-col lg="2">Final: </b-col>
                                    <b-col><b-form-input v-model="labelEnd" id="labelEnd" type="number" :min="item.labelStart" :max="item.labelEnd" :class="labelEndField"></b-form-input></b-col>
                                </b-row>
                                
                            </b-form-group>          
                            </b-form>
                        </b-col>
                    </b-row>

                
                    <div slot="footer" class="text-right">
                    <!--
                    <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="enableDisable()" v-show="this.selectedItem.id && this.selectedItem.st=='I'"><i class="fa fa-times"></i><span>Habilitar</span></b-button>
                    <b-button variant="html5" class="mr-1 btn-brand" @click="enableDisable()" v-show="this.selectedItem.id && this.selectedItem.st=='A'"><i class="fa fa-times"></i><span>Desabilitar</span></b-button>
                    <b-button variant="vine" class="mr-1 btn-brand" @click="create()"><i class="fa fa-tags"></i><span>Criar Etiquetas</span></b-button>
                    -->                    
                    <b-button variant="github" class="mr-1 btn-brand" @click="printLabel()"><i class="fa fa-print"></i><span>Imprimir Faixa de Etiqueta</span></b-button>
                    
                    </div>
                        
                </div>
                </b-form>

            </b-card>
        </b-modal>

        <b-modal title="Imprimir Etiqueta" centered class="modal" v-model="reprintModal" @ok="reprintItem" cancel-title="Cancelar" >
            Deseja realmente {{ selectedItem.statusId == 1 ? 'imprimir' : 'reimprimir' }} a etiqueta {{  String(selectedItem.labelNumber).padStart(6,'0') }}?
        </b-modal>
        
    </div>
</template>

<script>
import Vue from 'vue'
import axios from "axios";

/* Toast */
import VueNotifications from 'vue-notifications'
import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
import InventorySectorLabel from './InventorySectorLabel'

const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
}

miniToastr.init({types: toastTypes})

function toast ({title, message, type, timeout, cb}) {
    return miniToastr[type](message, title, timeout, cb)
}

const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
}
VueNotifications.setPluginOptions(options)

Vue.use(VueNotifications, options)
/* Toast - End */

export default {
    name: 'InventoryPrintComponent',
    props: {
        item: Object,
        inventoryId: Number
    },
    watch: {
        inventoryId: {
            immediate: true,
            handler(newValue) {
                this.selectedInventoryId = newValue ? newValue : 0
            }
        },
    },
    components: {
       
    },
    data: () => {
        return {
            statusDDL: [],
            printerId: 0,
            printerField: '',
            printerDDL: [],
            filters: {
                labelStart: '',
                labelEnd: '',
                statusId: 0
            },

            labelStart: null,
            labelStartField: '',
            labelEnd: null,
            labelEndField: '',

            selectedInventoryId: 0,

            selectedItem: {},

            modal: false,
            reprintModal: false,

            items: [],
            categoryTable: {
                isBusy: false,
                fields: [
                    { key: 'labelNumber', label: 'Etiqueta', sortable: true },
                    { key: 'printDate', label: 'Impresso em', sortable: true , thStyle: { width: "200px" }, class: 'text-center' },
                    { key: 'statusName', label: 'Status', sortable: true, thStyle: { width: "150px" }  },
                    { key: 'action', label: '', sortable: false, thStyle: { width: "40px" } }
                ],
                selectMode: 'single', 
                transProps: {
                    name: 'flip-list'
                },
                currentPage: 1,
                perPage: 50
            }

        }
    },
    computed: {
        totalRows: function () { return this.getRowCount() },
        selectStatusDDL: function() {
            var list = [...this.statusDDL]
            list = list.sort((a,b) => (a.text > b.text) ? 1 : -1)
            list.unshift({ value: '0' , text: '- Todos -' })
            return list
        },
    },
    methods: {
        getRowCount: function () {
            if(this.items)
                return this.items.length
            else
                return 0;
        },
        async reprintItem() {
            var s = this;
            if(this.selectedItem && this.selectedItem.id && this.selectedItem.id > 0) {
                await axios.get(
                    this.$store.state.ws_url + "/inventory/label/print?inventoryLabelId=" + this.selectedItem.id + "&printerName=" + this.printerId + "&uid=" + this.$store.state.currentUser.id + "&sid=" + this.$store.state.currentUser.sid
                ).then(function(resp) {
                    s.refreshData()
                    s.closeReprintModal()
                }).catch(function(error) {
                    console.log(error)
                })
            }
        },

        async printItem() {
            var s = this;
            await axios.get(
                this.$store.state.ws_url + "/inventory/label/print?inventoryId=" + s.inventoryId + "&printerName=" + this.printerId + "&labelStart=" + s.labelStart + "&labelEnd=" + s.labelEnd
                + "&uid=" + this.$store.state.currentUser.id + "&sid=" + this.$store.state.currentUser.sid
            ).then(function() {
                s.refreshData()
                s.closeModal()
            }
            ).catch(function (error) {
                console.log(error);                
            });
        },

        printLabel() {
            let containsError = false

            if(!this.printerId || this.printerId <= 0) {
                containsError = true
                this.printerField = 'is-invalid'
            }
            else {
                this.printerField = ''
            }
                
            if(!this.labelStart) {
                containsError = true
                this.labelStartField = 'is-invalid'
            }
            else {
                this.labelStartField = ''
            }
                
            if(!this.labelEnd) {
                containsError = true
                this.labelEndField = 'is-invalid'
            }
            else {
                this.labelEndField = ''
            }

            if(!containsError) {
                this.printItem()
            }
        },

        async create() {
            await axios.get(
                this.$store.state.ws_url + "/inventory/label/create?inventoryId=" + this.inventoryId + "&labelStart=" + (this.labelStart && this.labelStart >= 1 ? this.labelStart : '') + "&labelEnd=" +  (this.labelEnd && this.labelEnd >= 1 ? this.labelEnd : '') + "&uid=" + this.$store.state.currentUser.id + "&sid=" + this.$store.state.currentUser.sid,
            ).then(function(resp) {
                //console.log(resp.data.obj)
                toast ({
                    type: VueNotifications.types.info,
                    title: 'Etiqueta',
                    message: resp.data.obj,
                    timeout: 5000
                })

            }).catch(function(error) {
                console.log(error)

                toast ({
                    type: VueNotifications.types.error,
                    title: 'Etiqueta',
                    message: error,
                    timeout: 5000
                })
            })
        },
        
        rowClicked(item) {
            this.selectedItem = item
        },
        openReprintModal(item) {
            this.selectedItem = item
            this.reprintModal = true
        },
        closeReprintModal() {
            this.reprintModal = false
        },
       
        openModal() {
            this.modal = true
        },
        closeModal() {
            this.modal = false
        },
        async getPrinter() {
            var s = this;
            
            await axios.get(
                this.$store.state.ws_url + "/utils/printer/list"
            ).then(function(resp) {
                s.printerDDL = resp.data.obj;
            })
            .catch(function(error) {
                console.log(error);
            });
        
        },
        async getStatus() {
            var s = this;
            var currentUser = this.$store.state.currentUser;
          
            await axios.get(
                this.$store.state.ws_url + "/inventory/label/status/ddl?uid=" + currentUser.id + "&sid=" + currentUser.sid
            ).then(function(resp) {
                s.statusDDL = resp.data.obj
            }).catch(function(error) {
                console.log("Error: " + error)
            })
        },
        async refreshData() {
            var s = this;
            var currentUser = this.$store.state.currentUser;
            
            if(this.inventoryId && this.inventoryId > 0) {
              
                await axios.get(
                    this.$store.state.ws_url + "/inventory/label?inventoryId=" + s.selectedInventoryId + "&labelStart=" + s.filters.labelStart + "&labelEnd=" + s.filters.labelEnd + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
                ).then(function(resp) {
                    s.items = resp.data.obj;
                })            
                .catch(function(error) {
                    console.log(error);
                });     
            }
            else {
                s.items = []
            }
               
        }    
    },
    mounted: function() {
        this.filters.labelStart = this.item.labelStart
        this.filters.labelEnd = this.item.labelUsed
        this.getStatus()
        this.getPrinter()
        //this.refreshData()
    }
}
</script>